(function () {
  // Run only when the Clocklanta theme is active
  try {
    var hostname = (location.hostname || "").toLowerCase();
    var isClock =
      document.body &&
      document.body.classList &&
      document.body.classList.contains("theme-clocklanta");
    if (!(isClock || hostname.indexOf("clocklanta") !== -1)) return;

    // Avoid running in the theme editor or admin
    if (window.Shopify && window.Shopify.designMode) return;

    // Only run on the storefront root (homepage). Prevent replacing content on product/collection pages.
    var pathname = (location.pathname || "").replace(/\/+$/, "");
    if (pathname !== "" && pathname !== "/") return;

    // Small debounce to allow the theme's main element to be present
    setTimeout(function () {
      var main =
        document.getElementById("MainContent") ||
        document.querySelector("main");
      if (!main) return;

      // Fetch the Clocklanta collection JSON and render a simple grid
      fetch("/collections/clocklanta-1/products.json?limit=24")
        .then(function (res) {
          if (!res.ok) throw new Error("status:" + res.status);
          return res.json();
        })
        .then(function (data) {
          var products = data.products || [];
          var html =
            '<div class="collection section-home-switcher page-width">';

          if (products.length) {
            html +=
              '<ul class="grid product-grid grid--4-col-desktop grid--2-col-tablet-down">';
            products.forEach(function (p) {
              var img =
                p.images && p.images[0] && p.images[0].src
                  ? p.images[0].src
                  : "";
              var price =
                p.variants && p.variants[0] && p.variants[0].price
                  ? p.variants[0].price
                  : "";
              html += '<li class="grid__item">';
              // Use Dawn-like card structure so component CSS sizes/positions media correctly
              html +=
                '<a class="clocklanta-card card-wrapper product-card-wrapper card card--card card--standard card--media" href="/products/' +
                (p.handle || "") +
                '">';

              // card inner wrapper
              html += '<div class="card__inner">';

              // media area matching Dawn: .card__media > .media > img
              if (img) {
                html +=
                  '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
                  '<img loading="lazy" src="' +
                  img +
                  '" alt="' +
                  (p.title || "") +
                  '"></div></div>';
              }

              // content
              html +=
                '<div class="card__content"><h3 class="card__title">' +
                (p.title || "") +
                "</h3>";
              if (price)
                html += '<div class="card__price">$' + price + "</div>";

              // close wrappers
              html += "</div></div></a></li>";
            });
            html += "</ul>";
          } else {
            html +=
              '<div class="collection__empty">No Clocklanta products found — please create a collection named "clocklanta-1" with products.</div>';
          }

          html += "</div>";
          main.innerHTML = html;
          try {
            // Remove any leftover SlopDrop featured product modals that were server-rendered
            document.querySelectorAll("product-modal").forEach(function (pm) {
              try {
                var id = (pm.id || "").toLowerCase();
                var ds = (
                  (pm.getAttribute && pm.getAttribute("data-section")) ||
                  ""
                ).toLowerCase();
                if (
                  id.indexOf("featured_product") !== -1 ||
                  ds.indexOf("featured_product") !== -1 ||
                  id.indexOf("featured-product") !== -1
                ) {
                  pm.parentNode && pm.parentNode.removeChild(pm);
                }
              } catch (e) {}
            });
          } catch (e) {}
          try {
            document.body.classList.remove("clocklanta-loading");
          } catch (e) {}
        })
        .catch(function () {
          /* fail silently */
        });
    }, 250);
  } catch (e) {}
})();
